Ext.define('SA.VectorMapFilterExpressions', {
    singleton: true,

    fromFilter(filter) {
        var expressions = filter.getPredicates().map(predicate => {
            var attributeExpression = ['get', predicate.getAttribute()],
                comparand = predicate.getComparand(),
                expression;

            if (predicate.isBetween()) {
                let [min, max] = comparand;

                expression = ['all', ['>=', attributeExpression, min], ['<=', attributeExpression, max]];
            }
            else if (predicate.isEqual()) {
                expression = ['==', attributeExpression, comparand];
            }
            else if (predicate.isGreaterThan()) {
                expression = ['>', attributeExpression, comparand];
            }
            else if (predicate.isGreaterThanOrEqual()) {
                expression = ['>=', attributeExpression, comparand];
            }
            else if (predicate.isLessThan()) {
                expression = ['<', attributeExpression, comparand];
            }
            else if (predicate.isLessThanOrEqual()) {
                expression = ['<=', attributeExpression, comparand];
            }
            else if (predicate.isNotEqual()) {
                expression = ['!=', attributeExpression, comparand];
            }

            return ['case', ['!=', attributeExpression, null], expression, false];
        });

        if (filter.isAnd()) {
            return ['all', ...expressions];
        }
        else if (filter.isOr()) {
            return ['any', ...expressions];
        }
    },

    not(expression) {
        return ['!', expression];
    }
});